import React from 'react';
import { useSelector } from 'react-redux';

import { Grid, Typography } from '@material-ui/core';
import { Row } from '../../Resources';
import ActivitiesRegistrationHeader from 'components/ActivitiesRegistrationDetails/ActivitiesRegistrationHeader';

import { convertToReal, minutesToHoursAndMinutes } from 'helpers/converters';
import { formatServicesCategories } from 'helpers/formatters';

const formatExecutionTime = executionTime => {
  if(executionTime === null || executionTime === undefined || executionTime === '') {
    return '--';
  }

  return minutesToHoursAndMinutes(executionTime);
}

export default function ServiceUpdate({ activityData, lastRegister, newRegister }) {
  const servicesCategories = useSelector(state => state.filters)
    ?.selects
    ?.find(filter => filter?.id == 'serviceCategory')
    ?.options;

  return(
    <Grid container>
      <Grid xs={12}>
        <ActivitiesRegistrationHeader
          activityData={activityData}
        />
        <Grid container style={{ marginTop: 10 }}>
          <Grid xs={12} style={{ padding: 5 }}>
            <Typography color='primary' style={{ marginBottom: 5, borderBottom: '1px solid #E4E7EA' }}>
              <b>Registro Anterior</b>
            </Typography>
            <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
              {Object.keys(lastRegister).includes('description') && (
                <Row>
                  <Typography color='primary'>
                    <b>Descrição</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {lastRegister?.description || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('amount') && (
                <Row>
                  <Typography color='primary'>
                    <b>Valor</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {convertToReal(lastRegister?.amount)}
                  </Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('detailing') && (
                <Row>
                  <Typography color='primary'>
                    <b>Detalhamento</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {lastRegister?.detailing || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('categories') && (
                <Row>
                  <Typography color='primary'>
                    <b>Categorias</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {formatServicesCategories(lastRegister?.categories, servicesCategories)}
                  </Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('eventScheduling') && Object.keys(lastRegister?.eventScheduling || {}).includes('executionTime') && (
                <Row>
                  <Typography color='primary'>
                    <b>Tempo de execução</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {formatExecutionTime(lastRegister?.eventScheduling?.executionTime)}
                  </Typography>
                </Row>
              )}
            </Grid>
          </Grid>
          <Grid xs={12} style={{ padding: 5 }}>
            <Typography color='primary' style={{ marginTop: 10, marginBottom: 5, borderBottom: '1px solid #E4E7EA' }}>
              <b>Novo Registro</b>
            </Typography>
            <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
              {Object.keys(newRegister).includes('description') && (
                <Row>
                  <Typography color='primary'>
                    <b>Descrição</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {newRegister?.description || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('amount') && (
                <Row>
                  <Typography color='primary'>
                    <b>Valor</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {convertToReal(newRegister?.amount)}
                  </Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('detailing') && (
                <Row>
                  <Typography color='primary'>
                    <b>Detalhamento</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {newRegister?.detailing || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('categories') && (
                <Row>
                  <Typography color='primary'>
                    <b>Categorias</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {formatServicesCategories(newRegister?.categories, servicesCategories)}
                  </Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('eventScheduling') && Object.keys(newRegister?.eventScheduling || {}).includes('executionTime') && (
                <Row>
                  <Typography color='primary'>
                    <b>Tempo de execução</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {formatExecutionTime(newRegister?.eventScheduling?.executionTime)}
                  </Typography>
                </Row>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}